import React from 'react'

const UnknownIndicator = ({indicator}) => {
    console.log('Unknown indicator: ', indicator)

    return null
}
export default UnknownIndicator
